<template>
    <rkm-area
        class="mb-3"
        title="Histórico de exames"
        type="fieldset"
    >
        <List :data="data" />
    </rkm-area>
</template>

<script>
// Components.
import List from './List'

export default {
    components: {List},
    props: {
        data: {type: Object, required: true},
    },
}
</script>